import currency from 'currency.js';

export const formatCurrency = (amount, {numberOnly = false, symbol = '$'} = {}) => {
  if (typeof amount !== 'number') return '';
  const options = {
    symbol: numberOnly ? '' : symbol,
  };
  const string = currency(amount).format(options);
  return string;
};